import { useEffect, useMemo, useState } from 'react';
import { useLazyGetAllInterestsQuery } from 'src/app/redux/interests/interestsSlice';
import { BulkInterestLookupDataType, InterestsWithNamesLookup } from 'src/app/services/interest/interest.service.type';

const BATCH_SIZE = 100;

const useBulkInterestList = ({ ids }: BulkInterestLookupDataType & { ids: string[] }) => {
  const [interestList, setInterestList] = useState<InterestsWithNamesLookup>();

  const [lookup] = useLazyGetAllInterestsQuery();

  const stableIds = useMemo(() => {
    return ids.length === 0 ? [] : [...new Set(ids)];
  }, [JSON.stringify(ids)]);

  const fetchInterestDetails = async (idList: string[]) => {
    const results: InterestsWithNamesLookup = { count: 0, rows: [] };
    try {
      for (let i = 0; i < idList.length; i += BATCH_SIZE) {
        const batch = idList.slice(i, i + BATCH_SIZE);
        const response = await lookup({ ids: batch }).unwrap();
        response.rows.forEach((res) => {
          const foundResult = results.rows.find((obj) => obj.interestType === res.interestType);
          results.count += res.interests.length;
          if (!foundResult) {
            results.rows.push(res);
          } else {
            const merged = [...foundResult.interests, ...res.interests];
            results.rows[results.rows.indexOf(foundResult)] = {
              ...foundResult,
              interests: merged,
            };
          }
        });
      }
      // const interestMap = new Map(results.map((i: any) => [i.id, i]));
      // return interestMap;
    } catch (error) {
      console.log('error', error);
    }
    return results;
  };

  useEffect(() => {
    fetchInterestDetails(stableIds).then((interestMap) => {
      setInterestList(interestMap);
    });
  }, [stableIds]);

  return interestList;
};

export default useBulkInterestList;
